import React from 'react'
import './Testimonial.css'
import {Swiper, SwiperSlide} from 'swiper/react'
import profilePic1 from "../../img/addiv.jpg";
import profilePic2 from "../../img/letsdrop.jpg";

import { Pagination } from "swiper";
import 'swiper/css/pagination';
import 'swiper/css';
import { themeContext } from '../../Context'
import { useContext } from 'react'



const Testimonial = () =>{
    

    const theme = useContext(themeContext);
    const darkMode = theme.state.darkMode

    const clients = [
        {
            img : profilePic1,
            review : "I would like to say a big 'Thank You' for your immense effort and support. In addition, I have feeling that our further events are going to be Great as well, good luck to you.",
        },
        {
            img : profilePic2,
            review : "You'll get the best of what you put in. The team is working at their best to provide us what we want. Had a great experience working with them. Thanks a lot.",
        },
    ]
    return(
        <div className="t-wrapper" id="Testimonials">
            <div className="t-heading">
                <span>Clients always get </span>
                <span>Exceptional Work </span>
                <span> from me . . .</span>

                <div className="blur t-blur1" style={{ background: "var(--purple)" }}></div>
                <div className="blur t-blur2" style={{ background: "skyblue" }}></div>
            </div>

            {/* slider */}
            <Swiper
            modules={[Pagination]}
            slidesPerView={1}
            pagination={{clickable: true}}
            grabCursor={true}
            
            >
                {clients.map((client, index) => {
                    return(
                        <SwiperSlide key={index}>
                            <div className="testimonial">
                                <img src={client.img} alt=""/>
                                <span style={{color: darkMode? 'white': ''}}>{client.review}</span>
                            </div>
                        </SwiperSlide>
                    );
                })}
            </Swiper>

        </div>
    )
}

export default Testimonial